import { render, staticRenderFns } from "./AzPersonsAssignTemplatesDialog.vue?vue&type=template&id=36568e1f"
import script from "./AzPersonsAssignTemplatesDialog.vue?vue&type=script&lang=js"
export * from "./AzPersonsAssignTemplatesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports